var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeksualna(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "6618231191646029878 1",
    clipPath: "url(#clip0_66_4168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.3193 5.70675V2.72115L9.6877 4.08955L10.1542 3.62305L7.77505 1.2439L5.3959 3.6386L5.8624 4.1051L7.2308 2.7367V5.7223C5.10045 5.98665 3.45215 7.806 3.45215 9.99855C3.45215 12.3621 5.3959 14.3059 7.77505 14.3059C10.1542 14.3059 12.0979 12.3777 12.0979 9.983C12.0979 7.79045 10.4496 5.9711 8.3193 5.70675ZM7.77505 13.6839C5.738 13.6839 4.07415 12.02 4.07415 9.983C4.07415 7.94595 5.738 6.29765 7.77505 6.29765C9.8121 6.29765 11.4759 7.9615 11.4759 9.99855C11.4759 12.0356 9.8121 13.6839 7.77505 13.6839Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66_4168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.55,
    height: 15.55,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeksualna);
export default __webpack_public_path__ + "static/media/seksualna.4e5d93afdd77032843e2396a25fc5da0.svg";
export { ForwardRef as ReactComponent };